import { useEffect, useMemo, useState, useRef } from "react";
import "./LeftRail.css";

export default function LeftRail(props) {
  var sections = Array.isArray(props.sections) ? props.sections : [];
  var railLeft = typeof props.railLeft === "number" ? props.railLeft : 100;
  var navHeight = typeof props.navHeight === "number" ? props.navHeight : 88;
  var dotSize = typeof props.dotSize === "number" ? props.dotSize : 16;
  var dotsSide = props.dotsSide === "right" ? "right" : "left";
  var dotsGap = typeof props.dotsGap === "number" ? props.dotsGap : 14;
  var dotsVAlign = props.dotsVAlign === "center" ? "center" : "below-nav";

  var ids = useMemo(function () {
    var arr = [];
    for (var i = 0; i < sections.length; i += 1) arr.push(sections[i].id);
    return arr;
  }, [sections]);

  var [activeId, setActiveId] = useState(ids.length > 0 ? ids[0] : "");
  const [leavingIds, setLeavingIds] = useState(new Set());   // 👈 кои са в „reverse“
  const timersRef = useRef(new Map());

  function markLeaving(id) {
    if (!id) return;
    setLeavingIds(prev => {
      const next = new Set(prev);
      next.add(id);
      return next;
    });
    // чистим след края на анимацията (синхронизирай с CSS duration)
    const t = setTimeout(() => {
      setLeavingIds(prev => {
        const next = new Set(prev);
        next.delete(id);
        return next;
      });
      timersRef.current.delete(id);
    }, 1100); // 1.1s = колкото е CSS анимацията
    // ако вече има таймер – чистим стария
    if (timersRef.current.get(id)) clearTimeout(timersRef.current.get(id));
    timersRef.current.set(id, t);
  }

  useEffect(function () {
    if (ids.length === 0) return;

    var opts = { root: null, rootMargin: "-40% 0px -40% 0px", threshold: 0 };
    var io = null;

    function onIntersect(entries) {
      var best = null;
      var bestDist = Infinity;
      var center = window.innerHeight / 2;
      for (var i = 0; i < entries.length; i += 1) {
        var e = entries[i];
        if (!e.isIntersecting) continue;
        var r = e.target.getBoundingClientRect();
        var d = Math.abs(r.top + r.height / 2 - center);
        if (d < bestDist) { bestDist = d; best = e.target; }
      }
      if (best && typeof best.id === "string") setActiveId(best.id);
    }

    if (typeof window !== "undefined" && typeof window.IntersectionObserver === "function") {
      io = new IntersectionObserver(onIntersect, opts);
      for (var j = 0; j < ids.length; j += 1) {
        var el = document.getElementById(ids[j]);
        if (el) io.observe(el);
      }
    } else {
      function onScroll() {
        var center = window.innerHeight / 2;
        var bestId = "";
        var bestD = Infinity;
        for (var k = 0; k < ids.length; k += 1) {
          var el2 = document.getElementById(ids[k]);
          if (!el2) continue;
          var r2 = el2.getBoundingClientRect();
          var d2 = Math.abs(r2.top + r2.height / 2 - center);
          if (d2 < bestD) { bestD = d2; bestId = ids[k]; }
        }
        if (bestId) setActiveId(bestId);
      }
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
      io = { disconnect: function () { window.removeEventListener("scroll", onScroll); } };
    }

    return function () { if (io && typeof io.disconnect === "function") io.disconnect(); };
  }, [ids]);
    useEffect(() => {
    return () => {
      timersRef.current.forEach(t => clearTimeout(t));
      timersRef.current.clear();
    };
  }, []);

  function scrollToId(id) {
    var el = document.getElementById(id);
    if (!el) return;
    window.scrollTo({
      top: window.pageYOffset + el.getBoundingClientRect().top - navHeight,
      behavior: "smooth"
    });
    if (id !== activeId) markLeaving(activeId);   // 👈 пусни reverse на старата
    setActiveId(id);
  }

const goNextSession = () => {
  const currIndex = sections.findIndex(s => s.id === activeId); // ✅ правилно
  if (currIndex === -1) return;

  const nextIndex = (currIndex + 1) % sections.length;          // wrap-around
  const next = sections[nextIndex];

  if (next && next.id !== activeId) markLeaving(activeId);      // reverse на старата
  setActiveId(next.id);
  scrollToId(next.id);
};

  // хоризонтално позициониране на точките спрямо линията
  var dotsLeft = (dotsSide === "right" ? 1 : -1) * dotsGap - Math.round(dotSize / 2);
  var hintLeft = (dotsSide === "right" ? 1 : -1) * dotsGap;

  // вертикално позициониране
  var dotsStyle = { left: dotsLeft + "px" };
  if (dotsVAlign === "center") {
    dotsStyle.top = "50%";
    dotsStyle.transform = "translateY(-50%)";
  } else {
    dotsStyle.top = navHeight + 24 + "px";
  }

  return (
    <aside className="left-rail" style={{ left: railLeft + "px" }}>
      <i className="rail-line" aria-hidden="true" />

      <ul className="rail-dots" style={dotsStyle} aria-label="Section navigation">
        {sections.map(function (s) {
          var isActive = s.id === activeId;
          const isLeaving = leavingIds.has(s.id);
          return (
            <li key={s.id}>
              <button
                type="button"
                className={"rail-dot" + (isActive ? " is-active" : "") +
                  (isLeaving ? " is-leaving" : "")}
                onClick={function () { scrollToId(s.id); }}
                aria-label={s.label}
                aria-pressed={isActive ? "true" : "false"}
                style={{ width: dotSize + "px", height: dotSize + "px" }}
              >
                <span className="rail-dot-core" />
                <svg className="rail-ring" viewBox="0 0 40 40" aria-hidden="true">
                  <circle className="ring" cx="20" cy="20" r="18" />
                </svg>
              </button>
            </li>
          );
        })}
      </ul>

      <div className="rail-scroll-hint" style={{ left: hintLeft + "px" }}>
        <span className="arrow">←</span>
        <span onClick={goNextSession} className="label">SCROLL</span>
      </div>
    </aside>
  );
}
